export function getBasePath(): string {
  // In development we assume everything is served from root.
  // @ts-ignore
  const env = process.env.NODE_ENV;
  if (env !== 'production') {
    return '/';
  }

  let pathname = window.location.pathname;
  // Normalize to a directory path.
  if (!pathname.endsWith('/')) {
    pathname = pathname.substring(0, pathname.lastIndexOf('/') + 1);
  }

  // The app can be hosted under a subpath (e.g. /mjlab/).
  // Resolve that base path by stripping known entry route prefixes.
  const markers = ['oauth', 'chatgpt-hand', 'coach', 'hand', 'mobile', 'computer', 'me', 'practice', 'calc', 'evplus', 'ev'];
  for (const m of markers) {
    const idx = pathname.indexOf(`/${m}/`);
    if (idx >= 0) {
      return pathname.slice(0, idx + 1);
    }
  }

  return pathname;
}

export function getWsUrl(): string {
  // @ts-ignore
  const env = process.env.NODE_ENV;
  if (env !== 'production') {
    return 'ws://localhost:1235';
  }

  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const wsHost = window.location.host;
  const basePath = getBasePath();
  return `${wsProtocol}//${wsHost}${basePath}ws`;
}
